import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import DeleteIcon from "@material-ui/icons/Delete";
import { DatabaseContext } from "../../contexts/DatabaseContext";
import { PatronContext } from "../../contexts/PatronContext";
import { PaneContext } from "../../contexts/PaneContext";
import { UserContext } from "../../contexts/UserContext";
import { Button } from "../ui/forms/Button";
import Axios from "axios";
import { useSnackbar } from "notistack";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

const PhotoPreview = () => {
  const [img, setImg] = useState(null);
  const { apiUrl } = useContext(DatabaseContext);
  const { Site } = useContext(UserContext);
  const { previewPanePhoto, updatePreviewPane } = useContext(PaneContext);
  const { patron, removePhoto } = useContext(PatronContext);
  const { enqueueSnackbar } = useSnackbar();
  const { externalID, firstName, lastName, hasPhoto } = patron;
  const patronLabel =
    Site.siteType === 0 || Site.siteType === 5 ? "student" : "staff";

  useEffect(() => {
    //loads selected photo as preview
    if (previewPanePhoto) setImg(previewPanePhoto);

    setImg(previewPanePhoto);
    if (!previewPanePhoto) setImg(null);
    return () => {
      setImg(null);
    };
  }, [apiUrl, hasPhoto, previewPanePhoto, externalID, Site.siteCode]);

  const WondePhoto = async () => {
    try {
      const res = await Axios.put(
        `${apiUrl}/api/sync/wonde/updateStudentPhoto/?siteCode=${Site.siteCode}&studentID=${externalID}`,
      );
      if (res.success == true) {
        window.alert("Photo downloaded Please refresh the Window.");
      } else {
        window.alert("Photo failed to download");
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, { variant: "error" });
    }
  };

  return img ? (
    <Container>
      <Name>
        {patron ? `${firstName} ${lastName}` : `No ${patronLabel} selected`}
      </Name>
      <img
        style={{ maxWidth: "100%", borderRadius: "1rem" }}
        src={img}
        alt={patron.externalID}
        onContextMenu={(e) => e.preventDefault()}
      />
      <Button
        colour="error"
        startIcon={<DeleteIcon />}
        onClick={() =>
          removePhoto(externalID).then(() => {
            setImg(null);
            updatePreviewPane(null);
          })
        }
        margin="2rem"
      >
        Remove photo
      </Button>
      <br />
      {/* {Site.wondeAllowed == true ? 
     
      (
        <Button
          colour='warning'
          startIcon={<ArrowDownwardIcon />}
          onClick={WondePhoto}
        >
          Import Wonde Photo
        </Button>):(
        <></>
      )} */}
    </Container>
  ) : (
    <Container>
      <Name>
        {patron ? `${firstName} ${lastName}` : `No ${patronLabel} selected`}
      </Name>
      <div>No Photo</div>
      <br />
      <br />
      <br />
      {/* {Site.wondeAllowed == true ? (
        <Button
          colour='warning'
          startIcon={<ArrowDownwardIcon />}
          onClick={WondePhoto}
        >
          Import Wonde Photo
        </Button>
      ) : (
        <></>
      )} */}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const Name = styled.p`
  font-size: 2rem;
  font-weight: 700;
  font-style: italic;
  align-self: flex-end;
  margin-bottom: 2rem;
`;

export default PhotoPreview;
